import { AfterContentInit, Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { DetailAccountModel, DetailRevolvingCreditModel } from 'src/app/shared/models/abre-cuentas.model';
import { AgreementsModel } from 'src/app/shared/models/agreements.model';
import { ClientProductModel } from 'src/app/shared/models/client-products.model';
import { ContactModel } from 'src/app/shared/models/contact.model';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { IProductsModel } from 'src/app/shared/models/products.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { ProductsBiocatchEnum, StepBiocatchEnum } from '../../../shared/enums/biocatchContext.enum';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { callbackAdjustCA, callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { OFFERS_STATUS_CONST } from 'src/app/shared/constants/offers-status.constants';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';

@Component({
  selector: 'app-successful-account-creation',
  templateUrl: './successful-account-creation.component.html',
  styleUrls: ['./successful-account-creation.component.scss'],
})
export class SuccessfulAccountCreationComponent implements OnInit {
  contactInfo: ContactModel;
  documentInfo: DocumentModel;
  detailAccountInfo: DetailAccountModel;
  ipAddress: string;
  currentDate: string;
  transactionkit: any = [];
  transaction: any = [];
  infoInferredIncomes: any;
  productSelected: IProductsModel;
  maskedPhone: string;
  accountNumber: string;
  agreementSelected: AgreementsModel;
  selectedProduct: IProductsModel;
  detailRevolvingCredit: DetailRevolvingCreditModel;
  pcoStatus: any;
  solicitationId: any;
  postLogin: boolean;
  product_type: string;
  productClient: boolean;
  selectedAccount: ClientProductModel;
  selectedAccountDetail: DetailAccountModel;
  copyAccount: any;
  /**
   * Set copies for the screen
   */
  screenCopies: any;
  /**
   * List to the steps
   */
  options: [any];
  /**
   * PCO obtained
   */
  resultPco: string;
  showRate = false;
  /**
   * Tipo de living place
   * leasing, cartera o hiptecario
   */
  /**
   * meses de plazo
   */
  mes: any;
  subtype: any;
  /**
   * Sublinea relacionada al subtype
   */
  codesubline: string;
  /**
   * Nombre Sublinea relacionada al subtype
   */
  subline: string;
  /**
   * Porcentaje de opcion de compra
   * Solo aplica para sublinea leasing habitacional
   * purchase: true or false
   * purchasePercent: % entregado por el simulador
   */
  purchase: any;
  purchasePercent: any;
  /**
   * Monto inicial solicitado de acuerdo a PCO
   */
  rateLiving: any;
  /**
   * Mock datos del simulador
   */
  simulator: any;
  /**
   * Monto aprobado PCO separador miles
   */
  amountPco: any;
  /**
   * Numero de caso entregado por Bizagi
   */
  caseNum: any;
  dataProducts: any[] = [];
  viewOptionMultiProduct: boolean;
  select_products: any[] = [];
  granted_product_multi: any[] = [];
  productsMulti: any;
  isCardDuality: any;
  multifranquicia: any = [1, 2, 3, 4];
  title: any;
  credits: any[] = [];
  tempcardcredits: any;
  cardcredits: any = {
    cupo_total: 0,
    details: [],
    virutal: {},
    items: [],
    subitems: [],
    title: '',
  };
  accounts: any[] = [];
  listcredits: any[] = [];
  brands: any;
  /**
   * Indicador si se tiene productos de
   * Aprobados En Firme
   */
  firmlyApproved: boolean;
  selectMethod: any;
  preLoginOnly: any;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private biocatchService: BioCatchService,
    private navigationService: NavigationService,
    public validationHelperService: ValidationHelperService,
    private requestService: RequestService,
    private firmlyApprovedService: FirmlyApprovedService,
    private bitacoraService: BitacoraService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private adjustEvent: AdjustEvent,
    private numberHelper: FormatNumberService,
  ) {
    this.headerService.show(false, false, true);
  }

  ngOnInit() {
    this.firmlyApproved = !this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme';
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    const preLoginOnly = this.biocatchService.isEvidenteCase();
    if ((product !== ProductsBiocatchEnum.VIV && !this.biocatchService.isAppCN()) ||
      (product === ProductsBiocatchEnum.VIV && preLoginOnly)) {
      this.biocatchService.changeContext(StepBiocatchEnum.oferta, product, false, preLoginOnly);
    }
    this.caseNum = this.abreCuentasService.getSolicitationId();
    this.selectMethod = this.abreCuentasService.getOutlaySelection();
    this.viewOptionMultiProduct = this.abreCuentasService.isCardDuality ? true : this.abreCuentasService.viewOptionMultiProduct;
    this.screenCopies = {};
    this.contactInfo = this.abreCuentasService.getContactInfo();
    // this.maskedPhone = this.validationHelperService.maskPhone(this.contactInfo.mobile_number);
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.productSelected = this.abreCuentasService.getproductSelected();
    console.log('Product selected Vinculación: ', this.productSelected);
    this.ipAddress = this.biocatchService.getCurrentScoreIp();
    this.currentDate = this.abreCuentasService.formatDateSpanish(true, new Date());
    this.listcredits = this.parametersService.getSetting(OpEnum.LIST_CREDITS);
    this.brands = this.parametersService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).subproductsName;
    if (this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
      this.rateLiving = this.abreCuentasService.getRatesLoan();
      const creditParamsLib = this.abreCuentasService.getAbreCuentasModel().creditParms;
      this.amountPco = `$${this.numberHelper.pcoFormat(creditParamsLib.maxAmountValue)}`;
      this.mes = creditParamsLib.maxPeriodValue;
      this.screenCopies = this.copyService.copies.successfull_gz_type_loan;
    }
    if (this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      const resultpc = this.abreCuentasService.getPcoModel();
      this.resultPco = resultpc.solicitation_status.status_code;
      const rates = this.requestService.getRates();
      this.rateLiving = `${rates[0].value}% ${rates[0].type}  (${rates[1].value}% ${rates[1].type})`;
      this.simulator = this.abreCuentasService.getSimulatorModel();
      this.mes = this.simulator.term;
      this.subtype = this.simulator.product_subtype;
      this.codesubline = this.simulator.product_subline;
      this.purchase = (this.subtype === 'LEA' &&
        (this.codesubline === '01' || this.codesubline === '07' || this.codesubline === '03')) ? true : false;
      this.purchasePercent = this.simulator.purchase;

      const amount =
        this.abreCuentasService.getAmountPcoAproved() !== undefined ?
          this.abreCuentasService.getAmountPcoAproved().toString() : '0';
      this.amountPco = amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
      // this.caseNum = resultpc.solicitation_id;
      this.setCopies(this.resultPco, this.productSelected.product_type);
    }
    if (this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE) {
      this.productClient = this.abreCuentasService.getClientProduct();
      if (this.abreCuentasService.getcreateProductSelected()) {
        this.selectedAccount = this.abreCuentasService.getcreateProductSelected();
      } else {
        this.selectedAccountDetail = this.abreCuentasService.getDetailAccountCreation();
      }
      console.log('Account selected: ', this.selectedAccount);
      console.log('Account selectedAccountDetail: ', this.selectedAccountDetail);
    }
    if ((this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
      this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
      this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) &&
      !this.firmlyApproved) {
      this.pcoStatus = this.abreCuentasService.getPcoModel().solicitation_status.status_code;
    }
    this.solicitationId = this.abreCuentasService.getSolicitationId();
    this.selectedProduct = this.abreCuentasService.getproductSelected();
    this.detailRevolvingCredit = this.abreCuentasService.getDetailRevolvingCreditCreation();
    console.log('getproductSelected: ', this.selectedProduct);
    if (this.productSelected.product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC) {
      if ((this.pcoStatus !== undefined && this.pcoStatus !== 'PCO03') ||
        this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
        this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
        this.getDetailAccountInfo();
      }
    }

    if (this.productSelected.product_type === BUSINESS_CONST.MULTI || this.viewOptionMultiProduct) {
      this.select_products = this.abreCuentasService.getProductsSelects();
      this.productsMulti = this.abreCuentasService.getPcoModel().granted_product_multi;
      this.productClient = this.abreCuentasService.getClientProduct();
      this.getCreditProducts();
    }
    console.log('this.documentInfo', this.documentInfo);
    this.title = this.copyService.getParametrizedCopy('successful_account_creation_title', [this.documentInfo.firstname]);
    console.log('this.title', this.title);
    this.accountDetail();
    if (!this.firmlyApprovedService.isEmpty()) {
      let product_list: any = [];
      product_list.push(this.productSelected);
      this.firmlyApprovedService.turnOffOffer(
        OFFERS_STATUS_CONST.PRODUCT_ACCEPTED.CODE,
        product_list);
    }
    this.saveBitacoraFirmlyApproved();
  }

  getDetailAccountInfo() {
    if (this.abreCuentasService.getPostlogin()) {
      const accounts = this.abreCuentasService.getcreateProductSelected();
      if ((this.productSelected.product_type === BUSINESS_CONST.PRODUCT_CODE_AHO || this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) ||
        (this.productSelected.product_type === BUSINESS_CONST.PRODUCT_CODE_NOM || this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL)) {
        this.detailAccountInfo = this.abreCuentasService.getDetailAccountCreation();
        this.accountNumber = this.detailAccountInfo.account_number.toString();
      } else {
        this.accountNumber =
          `${accounts.account_type === BUSINESS_CONST.PRODUCT_CODE_AHO ? 'Ahorros' : accounts.account_type === BUSINESS_CONST.PRODUCT_CODE_NOM ? 'Nomina' : ''} ${this.validationHelperService.maskPhone(accounts.account_id)}`;
      }
    } else {
      this.detailAccountInfo = this.abreCuentasService.getDetailAccountCreation();
      this.accountNumber = this.detailAccountInfo.account_number.toString();
      if (this.productClient) {
        this.accountNumber =
          `${this.selectedAccount.account_type} ${this.validationHelperService.maskPhone(this.selectedAccount.account_id)}`;
      }
    }
  }

  /**
   * Set copies living
   */
  setCopies(resultPco, producType) {
    switch (resultPco) {
      case 'PCO01':
        switch (producType) {
          case BUSINESS_CONST.PRODUCT_TYPE_LIVING:
            this.screenCopies = this.copyService.copies.succesfull_type_living;
            this.options = this.parametersService.getSetting(OpEnum.LIVING_SUCCESSFUL_LIST);
            break;
          default:
            break;
        }
        break;
      case 'PCO03':
        switch (producType) {
          case BUSINESS_CONST.PRODUCT_TYPE_LIVING:
            const simuladores = this.abreCuentasService.getSimulatorModel();
            this.amountPco = simuladores.available_amount.amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
            this.screenCopies = this.copyService.copies.succesfull_gz_type_living;
            console.log('solucion bug adjust');
            const productSelected = this.abreCuentasService.getproductSelected().product_type;
            if (productSelected === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
              const event = {
                eventToken: '7c4f6p',
                callbackParams: callbackAdjustCA,
              };
              this.adjustEvent.adjustTrackEvent(event);
            }
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  }
  /**
   * Summary sign-on completion
   */
  next() {
    this.navigationService.nextStep('200');
    // Implement me here :)
  }

  /**
   * Summary capture account details
   */
  accountDetail() {
    if (this.selectedProduct.code === '201') {
      this.agreementSelected = this.abreCuentasService.getAgreementSelected();
      return;
    }
    if (this.selectedProduct.code != '232') {
      this.transaction = this.parametersService.getSetting(OpEnum.TRANSACTION_KIT);
      this.infoInferredIncomes = this.abreCuentasService.getinfoInferredIncomes();
      this.transactionkit = this.transaction.filter(transaction =>
      (transaction.account_type === this.infoInferredIncomes.account_type &&
        transaction.segmentation_id === this.infoInferredIncomes.segmentation_id));
      this.transactionkit = this.transactionkit[0];
    }

  }

  creditCard() {
    if (this.granted_product_multi.filter(fil => (fil.granted_product.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
      fil.granted_product.product_code === BUSINESS_CONST.PRODUCT_CODE_TCR))) {
      this.dataProducts.push({
        product_type: BUSINESS_CONST.PRODUCT_TYPE_TC,
        product_code: BUSINESS_CONST.PRODUCT_CODE_TCR,
        details: [
          this.copyService.copies.detail_bonding_aprove_number,
          this.copyService.copies.detail_bonding_aprove_date_finish,
          this.copyService.copies.detail_bonding_send_phone,
        ],
        selectedProduct: this.abreCuentasService.getPayDayProductSelected(),
        cardType: this.abreCuentasService.getCardTypeModel(),
        card: this.abreCuentasService.getProductCard(),
      });
    }
  }

  freeInvestment() {
    if (this.granted_product_multi.filter(fil => (fil.granted_product.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
      fil.granted_product.product_code === BUSINESS_CONST.PRODUCT_CODE_FREE))) {
      this.dataProducts.push({
        product_type: BUSINESS_CONST.PRODUCT_TYPE_FREE,
        product_code: BUSINESS_CONST.PRODUCT_CODE_FREE,
      });
    }
  }

  revolving() {
    if (this.granted_product_multi.filter(fil => (fil.granted_product.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      fil.granted_product.product_code === BUSINESS_CONST.PRODUCT_CODE_CRP))) {
      this.dataProducts.push({
        product_type: BUSINESS_CONST.PRODUCT_TYPE_REVOLVING,
        product_code: BUSINESS_CONST.PRODUCT_CODE_CRP,
      });
    }
  }

  getCreditProducts() {

    if (this.productsMulti) {
      // credits
      this.credits = this.productsMulti.filter(filter => (
        (filter.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE || filter.product_type === BUSINESS_CONST.PRODUCT_CODE_ORD) ||
        (filter.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING || filter.product_type === BUSINESS_CONST.PRODUCT_CODE_CRP) ||
        (filter.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN || filter.product_type === BUSINESS_CONST.PRODUCT_CODE_LOA)
      ));

      console.log('credits', this.credits);
      // cardcredits
      if (this.productsMulti.filter(filter => (filter.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC
        || filter.product_type === BUSINESS_CONST.PRODUCT_CODE_TCR))) {
        this.tempcardcredits = this.productsMulti.filter(filter => (filter.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC
          || filter.product_type === BUSINESS_CONST.PRODUCT_CODE_TCR));
        this.tempcardcredits.forEach((element: any) => {
          if (element.reason_description === '1' && element.product_type === BUSINESS_CONST.PRODUCT_CODE_TCR) {
            element.virtual = true;
          } else {
            element.virtual = false;
            this.cardcredits.cupo_total += Number(element.available_amount.amount);
          }
          element.brand = this.brands[element.product_sub_type];
          element.expiration_date = element.expiration_date.substring(2, 7).split('-').reverse().join('/');
          element.available_amount.amount = element.available_amount.amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        });
        this.cardcredits.virutal = this.tempcardcredits.filter(filter => ((filter.virtual === true)))[0];
        this.cardcredits.subitems = this.tempcardcredits.filter(filter => ((filter.virtual === false)));
        this.cardcredits.items = this.tempcardcredits;
        this.cardcredits.details = [
          this.copyService.copies.detail_bonding_aprove_number,
          this.copyService.copies.detail_bonding_aprove_date_finish,
          this.copyService.copies.detail_bonding_send_phone,
        ];
        this.cardcredits.title = BUSINESS_CONST.PRODUCT_CODE_TCR;
        this.cardcredits.cupo_total = this.cardcredits.cupo_total.toString();
        this.cardcredits.cupo_total = this.cardcredits.cupo_total.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
      }

      console.log('cardcredits', this.cardcredits);

      // accounts
      const tempAccounts = this.productsMulti.filter(filter => (
        (filter.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS || filter.product_type === BUSINESS_CONST.PRODUCT_CODE_AHO) ||
        (filter.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL || filter.product_type === BUSINESS_CONST.PRODUCT_CODE_NOM)));
      if (tempAccounts.length === 0 && this.abreCuentasService.getcreateProductSelected()) {
        const accounts = this.abreCuentasService.getcreateProductSelected();
        const account = {
          product_id: accounts.account_id,
          product_type: accounts.account_type,
          product_sub_type: accounts.account_subtype,
          available_amount: {
            currency: '',
            amount: null,
            decimals: 0,
          },
          origin_amount: {
            currency: '',
            amount: null,
            decimals: 0,
          },
          expiration_date: '',
          reason_description: '',
        };
        this.accounts.push(account);
      } else {
        this.accounts = tempAccounts;
      }
      console.log('this.accounts', this.accounts);
    }
  }

  getTitle(product_type: any) {
    return this.listcredits.filter(item => item.code === product_type)[0].name;
  }

  saveBitacoraFirmlyApproved() {
    if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
      const bitacoraEvent = 'offeraprovedf_ ORD';
      this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    }
  }
  /**
   * Opens link to itau page
   *
   *
   * @memberof DetailAccountCreationComponent
   */
  openLink() {
    this.channelCommunicatorService.getImpl().openExternalBrowser(this.copyService.copies.successful_account_creation_link, 5, true);
  }

}
